import React from 'react'
import { IonButton, IonContent, IonHeader, IonIcon, IonPage, IonTitle, IonToolbar } from '@ionic/react'
import { goToPage } from '../helpers/app_actions'
import { arrowBack } from 'ionicons/icons'

const Error = () => {
  return (
    <IonPage className="cheap_desktop">
      <IonHeader class="modalHeader" slot="fixed">
        <IonToolbar>
          <IonButton 
            onClick={() => goToPage('/walk/home')} 
            className="modalButton"  
            slot="start" 
            fill="clear">
            <IonIcon 
              icon={arrowBack} 
              color="dark"
              size="large"/>
          </IonButton>
          <IonTitle>Felmeddelande</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        
      </IonContent>
    </IonPage>
  )
}

export default Error